import * as React from 'react';
import '@bitio/react-components/dist/index.css';
import { ThemeProvider as BitioThemeProvider } from '@bitio/react-components';

import * as ReactDOM from 'react-dom';
import { Provider, useSelector } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import Routes from 'constants/Route';
import configureStore from './store/configureStore';
import { ApplicationState } from 'store/definitions';

import { Route, generatePath, matchPath, match } from 'react-router';
import PricingPage from 'pages/Pricing';
import DateAdminPage from './pages/admin/Dates';
import UserAdminPage from './pages/admin/Users';
import EVPriceView from './containers/EVPriceView';
import styled, { createGlobalStyle, ThemeProvider } from 'styled-components';
import { defaultTheme } from 'constants/Theme';
import JTest from 'pages/Scratchpad/JTest';
import { ModalProvider } from 'components/Modal/useModalStack';
import { Facility, UISettings } from 'store/uiSettings/reducer';
import AppNavBar from 'constants/AppNavBar';
import { Zone, ZoneFlag } from 'store/zone/reducer';
import { UIState, initialUIState } from 'store/ui/reducer';
import { graphDataUpdater_2_0 } from 'store/updater_2_0';
import { FacilityPageProps } from 'topdefinitions';
import { facilityRouteQuery } from 'store/router/selector';
import Adjustments from 'pages/Adjustments';
import Schedule from 'pages/FacilitySchedule';
import TableDataProvider from 'pages/Adjustments/TableDataProvider';
import Forecast from 'pages/Forecast';
import Analysis from 'pages/Analysis';
import { LocalStorageProvider } from 'provider/useLocalStorage';
import Configuration from 'pages/Configuration';
import { getAdminStatus, getDevEnvironment } from 'store/uiSettings/selectors';
import { ConfigContextProvider } from 'pages/Configuration/contexts/configurationContext';
import { facilityLocalStorageKey } from 'containers/FacilityPicker';

const GlobalStyles = createGlobalStyle`
* {
    box-sizing: border-box;
    font-family: 'Source Sans 3', sans-serif !important;
}
#root{
  padding:20px 100px;
}

button:focus {
  outline: 0;
}
ul{
    padding-left: 0; /* Explicitly target the left padding */
    margin: 0;
}
`;

const AppWrap = styled.div`
  background-color: ${({ theme }) => theme.palette.text.bg};
  font-size: 16px;
  color: ${({ theme }) => theme.palette.text.fg};
`;
const Footer = styled.div`
  line-height: 50px;
  border-top: 1px solid rgb(216, 216, 216);
  margin-top: 80px;
`;

const TestC: React.FC<{}> = (props) => {
  // console.log('Facilities props?', props);
  return <div>Facilties:{JSON.stringify(props)}</div>;
};
const RestC: React.FC<{}> = (props) => {
  // console.log('Rest props?', props);
  return <div>Rest:{JSON.stringify(props)}</div>;
};

const AppRoot = () => {
  const isAdmin = useSelector(getAdminStatus);
  // const isDevelopmentEnv = useSelector(getDevEnvironment);
  // console.log('isDev:', isDevelopmentEnv);
  return (
    <ThemeProvider theme={defaultTheme}>
      <BitioThemeProvider>
        <GlobalStyles />
        <LocalStorageProvider>
          <ConfigContextProvider>
            <ModalProvider>
              <TableDataProvider>
                <AppNavBar />
                <AppWrap>
                  <Route path={Routes.AdminUsers} component={UserAdminPage} />
                  <Route path={Routes.AdminDates} component={DateAdminPage} />
                  <Route path={Routes.FacilityForecast} component={Forecast} />
                  {/* <Route path={Routes.FacilityRevenue} component={Revenue} /> */}
                  <Route path={Routes.FacilityAnalysis} component={Analysis} />
                  <Route
                    path={Routes.FacilityPricing}
                    component={PricingPage}
                  />
                  <Route
                    path={Routes.FacilityAdjustments}
                    component={Adjustments}
                  />
                  {isAdmin && (
                    <Route
                      path={Routes.Configuration}
                      component={Configuration}
                    />
                  )}
                  <Route path={Routes.EVPriceGraph} component={EVPriceView} />
                  <Route path={Routes.FacilitySchedule} component={Schedule} />
                  <Route exact path={Routes.JTest} component={JTest} />
                  <Route path={'/{:rest}'} component={RestC} />
                </AppWrap>
                <Footer>
                  <div>Powered by BlackCube Predictions AB</div>
                </Footer>
              </TableDataProvider>
            </ModalProvider>
          </ConfigContextProvider>
        </LocalStorageProvider>
      </BitioThemeProvider>
    </ThemeProvider>
  );
};

const alterZone = (zone: Zone) => {
  zone.zoneFlags = [];
  if (!!zone.config) {
    if (zone.config.IsElectric) {
      zone.zoneFlags.push(ZoneFlag.Electric);
    }
  }
};

const alterFacility = (facility: Facility) => {
  facility.facilityFlags = [];
  switch (facility.id) {
    case 18:
    //   facility.facilityFlags = [FacilityFlag.NoFutureGraphDisplay];
    //   break;
    default:
      break;
  }
};

export default async () => {
  const baseUrl = '/';
  const localFacility = localStorage.getItem(facilityLocalStorageKey);

  const history = createBrowserHistory({ window, basename: baseUrl } as any);

  const setup = (initialData?: ApplicationState) => {
    // console.log({
    //   ...initialData,
    // });
    const match = matchPath<FacilityPageProps['match']['params']>(
      window.location.pathname,
      facilityRouteQuery
    );
    var _firstFac = initialData?.uiSettings.sites.find(
      (f) => f.path === match?.params.facilityId
    );

    if (!_firstFac) {
      _firstFac = initialData?.uiSettings.sites.find(
        (f) => f.path === localFacility
      );
    }
    if (!!initialData?.uiSettings) {
      initialData.uiSettings.sites.forEach((facility) => {
        alterFacility(facility);
      });
    }
    if (!!initialData?.zoneData) {
      initialData!.zoneData!.forEach((zone: Zone) => {
        alterZone(zone);
      });
    }
    console.log(initialData?.uiSettings.sites);

    const firstFacility = !!_firstFac
      ? _firstFac
      : initialData?.uiSettings.sites[0];
    // TODO : TA BORT Temporary state
    let tmpMatch: match<{
      facilityId: string | undefined;
      zoneId?: string;
    }> | null;
    let uiOverride = {
      activeFacility: firstFacility!.path,
      activeZoneID: null,
      segments:
        (firstFacility?.segments.length ?? 0) > 1
          ? 'all'
          : firstFacility?.segments[0],
    } as Partial<UIState>;

    if (history.location.pathname === '/') {
      var pathData = {
        facilityId: firstFacility!.path,
      } as { facilityId: string; zoneId?: number };
      var facilityZones = initialData?.uiSettings.siteZones.filter(
        (f) => f.routePath === firstFacility?.path
      );
      if (!!facilityZones && facilityZones?.length > 5) {
        initialUIState.activeZoneIDs = [facilityZones![0].zoneId];
      } else if (!!facilityZones) {
        initialUIState.activeZoneIDs = facilityZones!.map((f) => f.zoneId);
      }
      history.replace(generatePath(Routes.FacilityForecastRevenue, pathData));
    } else if (
      (tmpMatch = matchPath(history.location.pathname, {
        path: Routes.Facilities,
      }))
    ) {
      uiOverride.activeFacility = tmpMatch.params.facilityId!;
      var facilityZones = initialData?.uiSettings.siteZones.filter(
        (f) => f.routePath === uiOverride.activeFacility
      );
      if (!!facilityZones && facilityZones?.length > 5) {
        initialUIState.activeZoneIDs = [facilityZones![0].zoneId];
        initialUIState.previousZoneIDsState = [facilityZones![0].zoneId];
      } else if (!!facilityZones) {
        initialUIState.activeZoneIDs = facilityZones!.map((f) => f.zoneId);
        initialUIState.previousZoneIDsState = facilityZones!.map(
          (f) => f.zoneId
        );
      }
      // history.replace(
      //   generatePath(Routes.FacilityForecastRevenue, tmpMatch.params)
      // );
    }

    const store = configureStore(history, [graphDataUpdater_2_0], {
      ...initialData,
      uiState: {
        ...initialUIState,
        ...uiOverride,
      },
    } as Partial<ApplicationState> as any);

    // Store a "global" window copy of the store so we can access it from the devtools.
    (window as any).tpStore = store;
    // console.log(store);
    // Get the application-wide store instance, prepopulating with state from the server where available.

    ReactDOM.render(
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <AppRoot />
        </ConnectedRouter>
      </Provider>,
      document.getElementById('root')
    );
  };

  try {
    let uiSettingsResult = await fetch('/api/priceui/v3/uisettings', {
      redirect: 'manual',
    });
    // console.log('UI-settings result,', uiSettingsResult);
    if (!uiSettingsResult.ok) {
      if (uiSettingsResult.status === 401) {
        // need login
        window.location.href =
          '/user/login?returnUrl=' +
          encodeURIComponent(window.location.pathname.toString());
        return;
      }
    }
    let uiSettings = (await uiSettingsResult.json()) as UISettings;
    // console.log('Downloaded UISETTINGS:', uiSettings);
    // TODO: massage stuff for initial-props
    setup({
      uiSettings: {
        ...uiSettings,
        isAPDemo: false,
        isDev: uiSettings.isDev,
      },
      eventData: uiSettings.events,
      zoneData: uiSettings.siteZones.map((sz) => {
        var pricings = uiSettings.pricings.filter(
          (f) => f.parentZoneId === sz.zoneId
        );
        var schedules = uiSettings.schedules.filter(
          (ss) => ss.dZoneID === sz.zoneId
        );
        var selected = uiSettings.pricings.find(
          (f) => f.parentZoneId === sz.zoneId && f.selected === true
        );
        return {
          id: sz.zoneId,
          gid: sz.gid,
          name: sz.zoneName,
          sitePath: sz.routePath,
          aggressivity: 3,
          pricings: pricings,
          schedules: schedules,
          exports: sz.exports,
          selectedPricing: !selected ? null : selected.id,
          config: sz.config,
          rules: sz.rules,
        } as Zone;
      }),
    } as Partial<ApplicationState> as any);
  } catch (e) {
    // console.log(e);
    alert('Load error, reloading');
    window.location.reload();
    return;
  }
  // no initial-data.
  //setup(undefined);
};

